import * as React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Button } from './button';

const Pagination = ({ className, ...props }) => (
  <nav
    role="navigation"
    aria-label="Pagination"
    className={cn('flex items-center gap-2', className)}
    {...props}
  />
);
Pagination.displayName = 'Pagination';

const PaginationContent = React.forwardRef(({ className, ...props }, ref) => (
  <ul ref={ref} className={cn('flex flex-wrap items-center gap-2', className)} {...props} />
));
PaginationContent.displayName = 'PaginationContent';

const PaginationItem = React.forwardRef(({ className, ...props }, ref) => (
  <li ref={ref} className={cn('list-none', className)} {...props} />
));
PaginationItem.displayName = 'PaginationItem';

const PaginationLink = ({ className, isActive, ...props }) => (
  <Button
    variant={isActive ? 'default' : 'ghost'}
    size="icon-sm"
    className={cn(
      'h-9 w-9 min-w-9 p-0',
      isActive && 'bg-primary-500 text-primary-900 hover:bg-primary-600 hover:text-primary-900',
      className
    )}
    aria-current={isActive ? 'page' : undefined}
    {...props}
  />
);
PaginationLink.displayName = 'PaginationLink';

const PaginationPrevious = ({ className, ...props }) => (
  <Button
    variant="ghost"
    size="icon-sm"
    className={cn('h-9 w-9 gap-1 pl-2.5 pr-2.5', className)}
    {...props}
  >
    <ChevronLeft className="h-4 w-4" />
    <span className="sr-only">Previous</span>
  </Button>
);
PaginationPrevious.displayName = 'PaginationPrevious';

const PaginationNext = ({ className, ...props }) => (
  <Button
    variant="ghost"
    size="icon-sm"
    className={cn('h-9 w-9 gap-1 pl-2.5 pr-2.5', className)}
    {...props}
  >
    <span className="sr-only">Next</span>
    <ChevronRight className="h-4 w-4" />
  </Button>
);
PaginationNext.displayName = 'PaginationNext';

export {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationPrevious,
  PaginationNext,
};
